import Swal from "sweetalert2";
import ApiService from "@/helpers/api.service";

/*
*  Created by: 	Jero Paolo Balucas
*  Description:	getModuleAccess - This function will fetch the access of role 
                to check if a specific module is should be accessed by the user
*  Referenced by: routes.js and most the pages inside src/views/pages
*  Params:		  category name, module name and/or submodule name
*/
export function getModuleAccess(categoryName, moduleName, submoduleName = "") {
  let userData = JSON.parse(localStorage.getItem("userData"));
  const API = new ApiService();
  return new Promise((resolve) => {
    API.post(`/roles/getUserAccess`, { email: userData.email }).then(
      ({ data }) => {
        // parse the user module access from the api
        let user = data.message.row;
        let access = user[0].access == null || user == "" ? null : JSON.parse(user[0].access);
        let category = access == null ? null : access.find(({ title }) => title == categoryName);
        let module = null;

        if (category != null || category != undefined ) {
          if (category.modules.find(({ name }) => name == moduleName) != undefined) {
            module = category.modules.find(({ name }) => name == moduleName);
          }
        }

        // check if submodule param is not empty, if yes, we will check that submodule for any access
        if (submoduleName != "") {
          let submodule = {};

          if (module == null || module.submodules.find(({ name }) => name == submoduleName) == undefined) {
            submodule = {
              access: {
                create: false,
                read: false,
                update: false,
                delete: false,
              }
            }
          } else {
            submodule = module.submodules.find(({ name }) => name == submoduleName).access;
          }
          resolve(submodule);
        } 
        // if submodule param is empty, meaning we are just checking the access of the module itself
        else {
          if (module == null || module == undefined) {
            module = {
              access: {
                create: false,
                read: false,
                update: false,
                delete: false,
              }
            }
          } else {
            module = category.modules.find(({ name }) => name == moduleName).access;
          }
          resolve(module);
        }
      }
    );
  });
}

/*
*  Created by: 	Jero Paolo Balucas
*  Description:	showAccessRestrictedModal - This function will show modal for user to know that he/she has limited access
*  Referenced by: routes.js
*  Params:		  no params
*/
export function showAccessRestrictedModal() {
  Swal.fire(
    "Access Restricted",
    "Looks like your access is limited. Please contact your administrator.",
    "warning"
  );
}
